import React from "react"
import { Modal, Button, Alert } from "react-bootstrap"

import * as Collaborator from '../services/collaborator-service'
import * as unitService from '../services/organizational-units-service'

import Input from '../components/Input'

export default class ImportModal extends React.Component {
  constructor(props, context) {
    super(props, context)

    this.handleShow = this.handleShow.bind(this)
    this.handleHide = this.handleHide.bind(this)
    this.importUnits = this.importUnits.bind(this)
    this.importCollaborators = this.importCollaborators.bind(this)
    this.import = this.import.bind(this)
    this.state = {
      show: undefined
    }
  }

  handleShow() {
    this.setState({ show: true })
  }

  selectFile(property, file) {
    this.file = file
  }

  importCollaborators() {
    this.setState({ status: 'IN_PROGRESS' })
    const reader = new FileReader()
    reader.onload = upload => {
      Collaborator.importCollaborators({ contents: upload.target.result }).then(result => {
        this.setState({ status: 'OK', result: result })
        this.handleHide()
      }).catch((error) => {
        this.setState({ status: 'ERROR', message: "Het bestand kan niet worden geïmporteerd" })
      })
    }
    reader.readAsDataURL(this.file)
  }

  importUnits() {
    this.setState({ status: 'IN_PROGRESS' })
    const reader = new FileReader()
    reader.onload = upload => {
      unitService.importUnits({ contents: upload.target.result }).then(result => {
        this.setState({ status: 'OK', result: result })
        this.handleHide()
      }).catch((error) => {
        this.setState({ status: 'ERROR', message: "Het bestand kan niet worden geïmporteerd" })
      })
    }
    reader.readAsDataURL(this.file)
  }

  import() {
    switch (this.props.importtype) {
      case 'collaborators':
        this.importCollaborators()
        break
      case 'unit':
        this.importUnits()
        break
      default:
        alert("not recognised import type!")
    }
  }

  handleHide() {
    this.setState({show: false, message: undefined }, this.props.reload())
  }

  render() {
    const { message } = this.state
    const { textbt, text } = this.props
    return (
      <div>
        <Button className="edit-entry action-btn" onClick={this.handleShow}>
          {textbt}
        </Button>

        <Modal
          {...this.props}
          show={this.state.show}
          onHide={this.handleHide}
          dialogClassName="custom-modal modal-new-employee"
          backdrop={false}>

          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-lg">
              {this.props.title}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            { message && <Alert bsStyle='danger'>{message}</Alert> }
            <div>
              <p>{text}</p>
            </div>
            <div>
              <Input type="file" onChange={this.selectFile.bind(this)} ref={ref => this.fileUpload = ref} />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="primary" onClick={this.import}>Uploaden</Button>
            <Button onClick={this.handleHide}>Annuleren</Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/ImportModal.js